import { __decorate } from "tslib";
import __NG_CLI_RESOURCE__0 from "./view-application-details-dams.component.html?ngResource";
import __NG_CLI_RESOURCE__1 from "./view-application-details-dams.component.scss?ngResource";
import { ChangeDetectionStrategy, ChangeDetectorRef, Component } from "@angular/core";
import { ApplicationBaseComponent } from "../../../../../shared/components/application-base/application-base.component";
import { SharedConstants } from "../../../../../shared/constants/shared.constants";
import { AflaModuleStrategyService } from "../../../../../shared/services/afla-module-strategy/afla-module-strategy.service";
import { ViewApplicationService } from "../../../view-application.service";
import { ActivatedRoute } from "@angular/router";
import { RouterParamsService } from "../../../../../shared/services/route-params.service";
import { AppControllerService } from "../../../../../app-controller.service";
import { CRUDOperation } from "../../../../../shared/models/crud-operation-enum.model";
import { ViewApplicationDetailsDamsConstants } from "./view-application-details-dams.constants";
import { take, takeUntil } from "rxjs/operators";
let ViewApplicationDetailsDamsComponent = class ViewApplicationDetailsDamsComponent extends ApplicationBaseComponent {
    aflaModuleStrategyService;
    viewApplicationService;
    route;
    routerParamsService;
    appController;
    changeDetectorRefs;
    detailsForm;
    validationMessages = ViewApplicationDetailsDamsConstants.VALIDATION_MESSAGES;
    descriptionFormControlName = ViewApplicationDetailsDamsConstants.DESCRIPTION_FORM_CONTROL_NAME;
    typeFormControlName = ViewApplicationDetailsDamsConstants.APPLICATION_TYPE_FORM_CONTROL_NAME;
    referenceNumberControlName = ViewApplicationDetailsDamsConstants.REFERENCE_NUMBER_CONTROL_NAME;
    dropdownPlaceholderMessage = SharedConstants.PLACEHOLDER_TEXT;
    referenceNumberLabel = ViewApplicationDetailsDamsConstants.REFERENCE_NUMBER_LABEL;
    removeLabel = SharedConstants.REMOVE_LABEL;
    typeLabel = ViewApplicationDetailsDamsConstants.APPLICATION_TYPE_LABEL;
    descriptionLabel = ViewApplicationDetailsDamsConstants.DESCRIPTION_LABEL;
    applicationTypes = [];
    saveBtnPlaceholder = ViewApplicationDetailsDamsConstants.SAVE_BUTTON_PLACEHOLDER;
    application;
    constructor(aflaModuleStrategyService, viewApplicationService, route, routerParamsService, appController, changeDetectorRefs) {
        super(route, routerParamsService, aflaModuleStrategyService);
        this.aflaModuleStrategyService = aflaModuleStrategyService;
        this.viewApplicationService = viewApplicationService;
        this.route = route;
        this.routerParamsService = routerParamsService;
        this.appController = appController;
        this.changeDetectorRefs = changeDetectorRefs;
    }
    ngOnInit() {
        this.listenForRouteParamChange();
        this.initForm();
        if (this.aflaModuleStrategyService.lookups.has("applicationTypes")) {
            this.applicationTypes = this.aflaModuleStrategyService.lookups.get("applicationTypes");
            this.getApplication();
        }
        else {
            this.getLookups();
        }
    }
    ngOnDestroy() {
        this._destroy$.next();
        this._destroy$.complete();
    }
    getApplication() {
        const params = {
            $filter: `jobId eq ${this.jobID}`,
        };
        this.viewApplicationService
            .getApplicationObservable(this.aflaModuleStrategyService.applicationServiceUrl, params)
            .pipe(takeUntil(this._destroy$), take(1))
            .subscribe({
            next: (response) => {
                this.onGetApplicationCompleted(response);
            },
            error: (error) => {
                this.appController.handleServerErrorMessage(ViewApplicationDetailsDamsConstants.STEP_TITLE, error, CRUDOperation.Get);
            }
        });
    }
    handleRouteChange() {
    }
    initForm() {
        const form = this.aflaModuleStrategyService.form.get("detailsForm");
        this.detailsForm = form;
    }
    onGetApplicationCompleted(response) {
        if (response && response.value.length > 0) {
            this.detailsForm.reset();
            const application = response.value[0];
            this.application = application;
            this.detailsForm.get(this.descriptionFormControlName).setValue(application.description);
            this.detailsForm.get(this.referenceNumberControlName).setValue(application.referenceNumber);
            this.detailsForm.get(this.descriptionFormControlName).disable();
            this.detailsForm.get(this.referenceNumberControlName).disable();
            let appType = null;
            this.applicationTypes.forEach(item => {
                if (item.value === application.type) {
                    appType = item;
                }
            });
            this.detailsForm.get(this.typeFormControlName).setValue(appType);
            this.detailsForm.get(this.typeFormControlName).disable();
        }
        this.changeDetectorRefs.detectChanges();
    }
    getLookups() {
        const params = {
            $filter: `moduleId eq ${this.moduleID} and (name eq 'ApplicationType')`,
        };
        this.viewApplicationService
            .getLookupsObservable(params)
            .pipe(takeUntil(this._destroy$), take(1))
            .subscribe({
            next: (response) => {
                this.onGetLookupsCompleted(response);
            },
            error: (error) => {
                this.appController.handleServerErrorMessage(ViewApplicationDetailsDamsConstants.STEP_TITLE, error, CRUDOperation.Get);
            }
        });
    }
    onGetLookupsCompleted(response) {
        const applicationTypes = [];
        if (response && response.value.length > 0) {
            response.value.forEach(item => {
                if (item.name === "ApplicationType") {
                    applicationTypes.push(JSON.parse(item.content));
                }
            });
        }
        this.aflaModuleStrategyService.lookups.set("applicationTypes", applicationTypes);
        this.applicationTypes = applicationTypes;
        this.getApplication();
    }
    static ctorParameters = () => [
        { type: AflaModuleStrategyService },
        { type: ViewApplicationService },
        { type: ActivatedRoute },
        { type: RouterParamsService },
        { type: AppControllerService },
        { type: ChangeDetectorRef }
    ];
};
ViewApplicationDetailsDamsComponent = __decorate([
    Component({
        standalone: false,
        selector: "app-view-application-details-dams",
        template: __NG_CLI_RESOURCE__0,
        changeDetection: ChangeDetectionStrategy.OnPush,
        styles: [__NG_CLI_RESOURCE__1]
    })
], ViewApplicationDetailsDamsComponent);
export { ViewApplicationDetailsDamsComponent };
